/* eslint-disable */
import actions from './actions';

const state = {
  isAuthenticated: false,
  user: {
    firstName: "",
    lastName: "",
    email: "",
    hash: "",
    gforcesUser: false,
    token: "",
  }
};

const getters = {
  isAuthenticated: state => {
    return state.isAuthenticated;
  },
  user: state => {
    return state.user;
  }
};

const mutations = {
  ['logout'](state) {
    state.isAuthenticated = false;
  },
  ['login'](state, data){
    state.isAuthenticated = true;
    state.user.firstName = data.firstName;
    state.user.lastName = data.lastName;
    state.user.email = data.email;
    state.user.hash = data.hash;
    state.user.gforcesUser = data.gforcesUser;
    state.user.token = data.access_token;
  }
};

export default {
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js